var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/verification/steps/sms-verification.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import OtpInput from 'react-otp-input';
import snackbar from 'soapbox/actions/snackbar';
import { confirmPhoneVerification, requestPhoneVerification } from 'soapbox/actions/verification';
import { Button, Form, FormGroup, PhoneInput, Text } from 'soapbox/components/ui';
import { useAppDispatch, useAppSelector } from 'soapbox/hooks';
const messages = defineMessages({
  verificationInvalid: {
    "id": "sms_verification.invalid",
    "defaultMessage": "Please enter a valid phone number."
  },
  verificationSuccess: {
    "id": "sms_verification.success",
    "defaultMessage": "A verification code has been sent to your phone number."
  },
  verificationFail: {
    "id": "sms_verification.fail",
    "defaultMessage": "Failed to send SMS message to your phone number."
  },
  verificationExpired: {
    "id": "sms_verification.expired",
    "defaultMessage": "Your SMS token has expired."
  }
});
const Statuses = {
  IDLE: 'IDLE',
  REQUESTED: 'REQUESTED',
  FAIL: 'FAIL'
};

const SmsVerification = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(state => state.verification.isLoading);
  const [phone, setPhone] = React.useState();
  const [status, setStatus] = React.useState(Statuses.IDLE);
  const [verificationCode, setVerificationCode] = React.useState('');
  const [requestedAnother, setAlreadyRequestedAnother] = React.useState(false);
  const isValid = !!phone;
  const onChange = React.useCallback(phone => {
    setPhone(phone);
  }, []);
  const handleSubmit = React.useCallback(event => {
    event.preventDefault();

    if (!isValid) {
      setStatus(Statuses.IDLE);
      dispatch(snackbar.error(intl.formatMessage(messages.verificationInvalid)));
      return;
    }

    dispatch(requestPhoneVerification(phone)).then(() => {
      dispatch(snackbar.success(intl.formatMessage(messages.verificationSuccess)));
      setStatus(Statuses.REQUESTED);
    }).catch(error => {
      var _error$response, _error$response$data;

      const message = ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || intl.formatMessage(messages.verificationFail);
      dispatch(snackbar.error(message));
      setStatus(Statuses.FAIL);
    });
  }, [phone, isValid]);
  const resendVerificationCode = React.useCallback(event => {
    setAlreadyRequestedAnother(true);
    handleSubmit(event);
  }, [isValid]);

  const submitVerification = () => {
    // TODO: handle proper validation from Pepe -- expired vs invalid
    dispatch(confirmPhoneVerification(verificationCode)).catch(() => dispatch(snackbar.error(intl.formatMessage(messages.verificationExpired))));
  };

  React.useEffect(() => {
    if (verificationCode.length === 6) {
      submitVerification();
    }
  }, [verificationCode]);

  if (status === Statuses.REQUESTED) {
    return /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 92,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "pb-4 sm:pb-10 mb-4 border-b border-gray-200 dark:border-gray-800 border-solid -mx-4 sm:-mx-10",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 93,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("h1", {
      className: "text-center font-bold text-2xl",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 94,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "sms_verification.sent.header",
      defaultMessage: "Verification code",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 95,
        columnNumber: 13
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "sm:pt-10 sm:w-2/3 md:w-1/2 mx-auto space-y-4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Text, {
      theme: "muted",
      size: "sm",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 100,
        columnNumber: 11
      }
    }, "We sent you a 6-digit code via SMS. Enter it below."), /*#__PURE__*/React.createElement(OtpInput, {
      value: verificationCode,
      onChange: setVerificationCode,
      numInputs: 6,
      isInputNum: true,
      shouldAutoFocus: true,
      isDisabled: isLoading,
      containerStyle: "flex justify-center mt-2 space-x-4",
      inputStyle: "w-10i border-gray-300 dark:bg-gray-800 dark:border-gray-800 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 104,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 115,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      type: "button",
      theme: "tertiary",
      onClick: resendVerificationCode,
      disabled: requestedAnother,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 116,
        columnNumber: 13
      }
    }, "Resend verification code?"))));
  }

  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-4 sm:pb-10 mb-4 border-b border-gray-200 dark:border-gray-800 border-solid -mx-4 sm:-mx-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-center font-bold text-2xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "sms_verification.header",
    defaultMessage: "Enter your phone number",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sm:pt-10 sm:w-2/3 md:w-1/2 mx-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    labelText: "Phone Number",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 141,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(PhoneInput, {
    value: phone,
    onChange: onChange,
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 142,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    block: true,
    theme: "primary",
    type: "submit",
    disabled: isLoading || !isValid,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 150,
      columnNumber: 13
    }
  }, "Next")))));
};

export { SmsVerification as default };